import * as React from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody, Typography, makeStyles, Button, Collapse, Grid, Link, ButtonGroup, IconButton } from '@material-ui/core';
import { useIifImportSelector, IifImportSelectors, IifImportActions, TransactionType } from '../store/modules/iifImport';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-duotone-svg-icons/faChevronDown';
import { faSync } from '@fortawesome/pro-duotone-svg-icons/faSync';
import { DateTime } from 'luxon'
import { classNames } from '../shared';
import AudCurrencyFormatter from '../utilities/currencyFormatter';
import { TaxMode, ApplicationSettingsSelectors, useApplicationSettingsSelector } from '../store/modules/applicationSettings';
import { red, yellow } from '@material-ui/core/colors';
import { RequestState } from '../store/modules';
import { useDispatch } from 'react-redux';
import ErrorView from './ErrorView';

interface IAttachmentViewProps {
    fileIndex: number;
    type: TransactionType;
    typeIndex: number;
    attachmentIndex: number;
    attachmentPosition: number;
}

const useStyles = makeStyles(theme => ({
    warning: {
        background: `${yellow[100]} !important`
    },
    error: {
        background: `${red[100]} !important`
    },
    button: {
        textAlign: 'center',
        minWidth: 'auto',
        padding: theme.spacing(1),

        '& svg': {
            transition: 'all 0.25s linear'
        }
    },
    expanded: {
        '& svg': {
            transform: 'rotate(180deg)'
        }
    },
    noPadding: {
        padding: theme.spacing(0)
    },
    padding: {
        padding: theme.spacing(2)
    }
}))

const AttachmentView: React.FunctionComponent<IAttachmentViewProps> = ({
    fileIndex,
    type,
    typeIndex,
    attachmentIndex,
    attachmentPosition
}) => {
    const dispatch = useDispatch();
    const attachment = useIifImportSelector(state => IifImportSelectors.selectAttachment(state, attachmentIndex));

    const classes = useStyles();

    const download = React.useCallback(() => {
        dispatch(IifImportActions.downloadAttachment(fileIndex, type, typeIndex, attachmentIndex));
    }, []);

    if (!attachment) {
        return null;
    }

    const hasError = attachment.downloadStatus?.state === RequestState.Failure || attachment.importStatus?.state === RequestState.Failure;
    const hasWarning = attachment.downloadStatus?.state !== RequestState.Success;
    const isDownloading = attachment.downloadStatus?.state === RequestState.Pending;

    const url = attachment.guid ? `/attachment/${attachment.guid}` : attachment.url;

    return (
        <>
            <TableRow className={classNames({ [classes.error]: hasError, [classes.warning]: hasWarning })}>
                <TableCell>{attachmentPosition}</TableCell>
                {/*<TableCell className={classNames({ [classes.error]: attachment.accountError })}>{attachment.account?.value}</TableCell>*/}
                <TableCell><Link href={url} target="_blank">{attachment.name}</Link></TableCell>
                <TableCell align="right">
                    <ButtonGroup>
                        {
                            hasWarning && !isDownloading && (
                                <Button
                                    color="primary"
                                    onClick={download}
                                >
                                    <FontAwesomeIcon icon={faSync} fixedWidth />
                                </Button>
                            )
                        }
                        {
                            isDownloading && (
                                <Button
                                    color="primary"
                                >
                                    <FontAwesomeIcon icon={faSync} spin fixedWidth />
                                </Button>
                            )
                        }
                    </ButtonGroup>
                </TableCell>
            </TableRow>
            {
                (attachment.downloadStatus?.responseStatus || attachment.importStatus?.responseStatus) && (
                    <TableRow>
                        <TableCell />
                        <TableCell colSpan={2}>
                            {
                                attachment.downloadStatus?.responseStatus && !attachment.importStatus?.responseStatus && (
                                    <ErrorView
                                        title="Attachment Download Failed"
                                        responseStatus={attachment.downloadStatus?.responseStatus}
                                    />
                                )
                            }
                            {
                                attachment.importStatus?.responseStatus && (
                                    <ErrorView
                                        title="Attachment Upload Failed"
                                        responseStatus={attachment.importStatus?.responseStatus}
                                    />
                                )
                            }
                        </TableCell>
                    </TableRow>
                )
            }
        </>
    );
}

export default AttachmentView;


// WEBPACK FOOTER //
// ./src/components/AttachmentView.tsx